import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { Col, Row } from 'react-bootstrap';
import Sections from '../EmailContent/Sections';
import startCase from '../../../../helpers/socratesLodash/startCase';
import capitalize from 'react-bootstrap/lib/utils/capitalize';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';
import './LetterContent.scss';

const Header = ({ input }) => {
  return <h2>{startCase(input.value)}</h2>;
};
const Letter = ({ fields, templates, letters, letterCategory }) => (
  <>
    {fields.map((data, key) => (
      <div key={key}>
        <Row>
          <Col sm={12}>
            <Field
              name={`meta.letter.${letterCategory}.content.${key}.attributes.name`}
              component={Header}
            />
          </Col>
        </Row>

        <Field
          name={`meta.letter.${letterCategory}.content.${key}.attributes.sections`}
          template={templates.find((template) => {
            return template.id === letters[key].relationships.template.data.id;
          })}
          component={Sections}
          index={key}
        />
      </div>
    ))}
  </>
);

const LetterContent = ({ templates, letters, letterCategory }) => {
  if (!templates) {
    return null;
  }
  return (
    <>
      <WhiteLabelContentContainer title={`${capitalize(letterCategory)} Letter content`}>
          <FieldArray
            name={`meta.letter.${letterCategory}.content`}
            component={Letter}
            letterCategory={letterCategory}
            templates={templates}
            letters={letters}
          />
      </WhiteLabelContentContainer>
    </>
  );
};
export default LetterContent;
